import { render, staticRenderFns } from "./crops.vue?vue&type=template&id=7dc39099&scoped=true&"
import script from "./crops.vue?vue&type=script&lang=js&"
export * from "./crops.vue?vue&type=script&lang=js&"
import style0 from "./crops.vue?vue&type=style&index=0&id=7dc39099&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc39099",
  null
  
)

export default component.exports